<div class="app-wrapper">
  <ngx-spinner [bdColor]="'rgba(0,0,0,0.64)'" [size]="'medium'" [color]="'#0b7b1c'" [type]="'ball-clip-rotate'" [fullScreen]="true"></ngx-spinner>
  <router-outlet></router-outlet>
</div>
